$(document).ready(function(){
  
  var faq_cat = $('.faq_filter_item.active').attr('data-filter');
  $('.faq_filter_item.active').parent().parent().parent().find('accordion-custom').hide();
  $('.faq_filter_item.active').parent().parent().parent().find('accordion-custom[data-category='+faq_cat+']').show();
    
  
  $('.faq_filter_item').click(function(){    
    var faq_cat = $(this).attr('data-filter');
    $('.faq_filter_item').removeClass('active');
    $(this).addClass('active');
    $(this).parent().parent().parent().find('accordion-custom').hide();
    $(this).parent().parent().parent().find('accordion-custom[data-category='+faq_cat+']').show();
  });

});